import { SelectionCustomCargoParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/CargoSelection/types';
import { CargoType } from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/interfaces';
import { $error } from '@settings/errorContext';
import { graphQLClient } from '@settings/services/graphQLClient';
import { GraphQLClient } from '@settings/services/graphQLClient/GraphQLClient';
import { loggerFactory } from '@settings/services/logger';
import { Logger } from '@settings/services/logger/Logger';

import { CargoConverterServiceInterface } from './interfaces';
import {
  SelectCargoParametersQuery,
  SelectCargoParametersQueryResponse,
} from './SelectCargoParametersQuery';

/**
 * Сервис подбора параметров груза
 */
export class CargoConverterService implements CargoConverterServiceInterface {
  private readonly client: GraphQLClient;

  private readonly logger: Logger;

  /**
   * Конструктор сервиса
   * @param token
   */
  constructor(token?: string) {
    this.client = graphQLClient(token);
    this.logger = loggerFactory().make(`CargoConverterService`);
  }

  /**
   * Подбор параметров груза
   *
   * @param params
   * @param cargoType
   */
  async GetSelectedParams(
    params: SelectionCustomCargoParameters[],
    cargoType: CargoType
  ): Promise<SelectCargoParametersQueryResponse['data'] | undefined> {
    try {
      const response = await this.client.Query<null, SelectCargoParametersQueryResponse>(
        new SelectCargoParametersQuery(params, cargoType),
        {}
      );
      this.logger.Debug(`Selected cargo parameters data`, response.data);

      return response.data;
    } catch (e) {
      this.logger.Error(`Error:`, e);
      $error.next(e);
    }
  }
}
